import type {
	RequestGetInquiries,
	RequestGetDetailInquiry,
	RequestSubmitInquiry,
	Inquiry,
	ResponseGetDetailInquiry,
} from "@schemas/inquiry";

import instance from "@utils/axiosInstance";
import type { MutationOpts } from "@utils/generateReactQuery";
import { useCreateMutation, useCreateQuery, type QueryOpts } from "@utils/generateReactQuery";

import type { DefaultResponseList } from "@/schemas/common";

const BASE_URL = "/inquiries";

const API = {
	getList: async (params: RequestGetInquiries) => await instance.get(`${BASE_URL}`, { params }),
	getDetail: async (params: RequestGetDetailInquiry) =>
		await instance.post(`${BASE_URL}/${params.id}`, {
			data: params.data,
		}),
	submit: async (params: RequestSubmitInquiry) =>
		await instance.post(`${BASE_URL}/submit`, params),
};

const KEY = {
	getList: (params: RequestGetInquiries) => ["/inquiries/list", params],
	getDetail: (params: RequestGetDetailInquiry) => ["/inquiries/detail", params],
};

export function useGetInquiries(
	params: RequestGetInquiries,
	options?: QueryOpts<DefaultResponseList<Inquiry>>,
) {
	return useCreateQuery<DefaultResponseList<Inquiry>>(
		KEY.getList(params),
		() => API.getList(params),
		{
			...options,
		},
	);
}

export function useGetInquiryDetail(
	options?: MutationOpts<ResponseGetDetailInquiry, RequestGetDetailInquiry>,
) {
	return useCreateMutation<ResponseGetDetailInquiry, RequestGetDetailInquiry>(API.getDetail, {
		...options,
	});
}

export function useSubmitInquiry(options?: MutationOpts<boolean, RequestSubmitInquiry>) {
	return useCreateMutation<boolean, RequestSubmitInquiry>(API.submit, options);
}
